

// Custom description hiding

if (document.querySelector(".product__description")) {
	let productDescriptionCustom = document.querySelectorAll(".product__description");
	productDescriptionCustom.forEach(description => {
		let ourButton = document.createElement('div');
		ourButton.classList.add('text-button');
		ourButton.innerText = "show more";
		description.after(ourButton);
		ourButton.addEventListener("click", () => {
			hideDesc();
		})
		ourButton.click();
		function hideDesc() {
			if (description.classList.contains("product__description--hide")) {
				description.style.height = "auto";
				description.classList.remove("product__description--hide")
				ourButton.innerText = "show less";
			} else {
				description.style.height = description.querySelector("span").offsetHeight +  "px";
				description.classList.add("product__description--hide");
				ourButton.innerText = "show more";
			}
		}
		window.addEventListener("resize", () => {
			description.style.height = description.querySelector("span").offsetHeight +  "px";
			description.classList.add("product__description--hide");
			ourButton.innerText = "show more";
		});
	});
}

if (document.querySelector(".product-form__input")) {
	let productVariants = document.querySelectorAll(".product-form__input")
	productVariants.forEach(variant => {
		let label = variant.querySelector('.form__label');
		let defaultText = label.innerText;
		let select = variant.querySelector('.select select');

		select.addEventListener("change", changeTitleVariant)
		function changeTitleVariant() {
			if (defaultText == "SCENT") {
				label.innerText = defaultText + ": " + select.value + " Incense";
			} else {
				label.innerText = defaultText + ": " + select.value;
			}
		}
		changeTitleVariant();
	});
}

if (document.querySelector(".custom--select")) {
	setTimeout(() => {
		let customSelector = document.querySelector('.custom--select');
		let label = customSelector.querySelector('.form__label');
		let select = customSelector.querySelector('.select select');
		if (select) {
			select.addEventListener("change", changeTitleVariant)
		}
		function changeTitleVariant() {
			label.innerText = "SCENT: " + select.selectedOptions[0].innerText;
			let localLink = document.createElement('a');
			localLink.setAttribute('hidden', '');
			localLink.href = select.value;
			localLink.click();
		}
	}, 1000);
}


setTimeout(() => {
	if (document.querySelector(".slider-thumbs__container")) {
		const carousel = new Flickity('.slider-thumbs__container .carousel-main');
		const carouselStatus = document.querySelector('.carousel-status');

		function updateStatus() {
			const cellNumber = carousel.selectedIndex + 1;
			carouselStatus.innerText = cellNumber + '/' + carousel.slides.length;
		}
		updateStatus();
		carousel.on( 'select', updateStatus );

		const carouselPrew = document.querySelector('.flickity-product-images-buttons .previous');
		const carouselNext = document.querySelector('.flickity-product-images-buttons .next');

		carouselPrew.addEventListener("click", () => carousel.previous( 0, 0 ))
		carouselNext.addEventListener("click", () => carousel.next( 0, 0 ))
	}
}, 1000);
